(function(){
'use strict';
function message(total,threshold,currency,label){
 if(!Number.isFinite(total)||threshold<=0)return null;
 const money=n=>new Intl.NumberFormat('en',{style:'currency',currency,currencyDisplay:'code'}).format(n/100);
 return total<threshold?`Spend ${money(threshold-total)} more for free standard shipping.`:'Free standard shipping threshold reached. Confirm delivery eligibility at checkout.';
}
if(typeof module==='object'&&module.exports){module.exports=message;return;}
let busy=false;
async function refresh(){
 if(busy||document.hidden)return;busy=true;
 try{
  const root=document.getElementById('gb-cart-value-context')?.dataset.root||'/';
  const r=await fetch(root.replace(/\/?$/,'/')+'cart.js',{cache:'no-store'});if(!r.ok)return;
  const cart=await r.json();
  document.querySelectorAll('[data-gb-shipping]').forEach(el=>{
   const target=el.querySelector('[data-gb-shipping-message]');
   if(!target||cart.currency!==el.dataset.currency)return;
   const text=el.dataset.country==='US' ? (cart.item_count<3 ? `Add ${3-cart.item_count} more item${3-cart.item_count===1?'':'s'} for free US shipping on rates up to $14.99. Express excluded.` : '3-item shipping minimum reached. US rates up to $14.99 are free. Express excluded; eligibility confirmed at checkout.') : message(cart.total_price,Number(el.dataset.threshold),cart.currency,el.dataset.label);
   if(text&&target.textContent!==text)target.textContent=text;
  });
 }catch(_){}finally{busy=false;}
}
['cart:updated','cart:refresh','cart:change','cart:open','theme:cart:change','theme:cart:updated','theme:cart-drawer:open'].forEach(e=>document.addEventListener(e,refresh));
window.addEventListener('pageshow',refresh);document.addEventListener('visibilitychange',refresh);
refresh();
})();
